import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: [
    'film_id'
  ],
  titles: [
    store.__('film')
  ],
  _sortField: 'film_id',
  initVals: (row) => ({control_timestamp: Math.round(new Date().getTime())}),
  validators: {
    'film_id': Validators.isMandatory(store),
    '_global': (vals, items) => {
      const existing = vals.has('film_id') && items && items.find((i) => (
        // i.platform === vals.get('platform') &&
        i.film_id === vals.get('film_id') && (
        (typeof i.id === 'undefined' && vals.has('id')) ||
        (i.id && i.id !== vals.get('id')) ||
        (i.control_timestamp && vals.has('control_timestamp') &&
        i.control_timestamp !== vals.get('control_timestamp')))
      ))
      const film = vals.has('film_id') &&
        store.options.get('films').find((i) => i.id === vals.get('film_id'))
      if (film && film.slug) {
        vals.set('slug', film.slug)
      }
      return existing
        ? [store.__('Selected "film" must be unique.')]
        : undefined
    }
  }
})
